/**
 * Bounds (mm) every interior dimension is clamped to, whether it is changed by
 * dragging a corner in the viewer or set programmatically.
 */
export const INTERIOR_MIN_SIZE = 50;
export const INTERIOR_MAX_SIZE = 5000;
